import { useEffect, EffectCallback } from 'react';

/*
  Run useEffect only once with/without deps
*/
export const useMountEffect = (effect: EffectCallback): void => {
  return useEffect(effect, []);
};
